import { createFileRoute, redirect } from "@tanstack/react-router";

// 企业智能体市场已并入行业包市场（团队设置 → 行业包），保留本路由仅作深链兼容
export const Route = createFileRoute("/_app/bot-market/")({
  beforeLoad: () => {
    throw redirect({ to: "/tenant-settings/industry-packs" });
  },
});
